import React, { useEffect, useRef, useState } from 'react'
import {
    Box,
    Card,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Button,
} from '@mui/material'
import { Formik } from 'formik'
import axios from 'axios';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import SupplierDetailsReport from '../Components/SupplierDetailReportFile'
import xlsx from 'json-as-xlsx';
import DoctorDetailsReport from './DoctorDetailsReport';


function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function DoctorReport() {
    const [pageTitle, setPageTitle] = useState('Doctor Details Report');
    const [doctorList, setDoctorList] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - doctorList.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        GetAllDoctorDetails();
    }, [])

    function GetAllDoctorDetails() {
        axios.get('https://serverfourpaws.ccsoftwares.com/Doctor/getAllActiveDoctorDetails').then((res) => {
            if (res.data.length > 0) {
                setDoctorList(res.data);
            } else {
                setDoctorList([]);
                toast.error("No records to display!");
            }
        })
    }

    async function createFile() {
        var file = await createDataFromExcel(doctorList);
        var settings = {
            sheetName: 'Doctor Detail Report',
            fileName: 'Doctor Detail Report',
            writeOptions: {}
        }
        let tempcsvHeaders = csvHeaders;
        tempcsvHeaders.push({ label: 'Doctor ID', value: 'DoctorID' })
        tempcsvHeaders.push({ label: 'Doctor Name', value: 'Name' })
        tempcsvHeaders.push({ label: 'ContactNo', value: 'Phone' })
        tempcsvHeaders.push({ label: 'Role', value: 'Role' })

        let dataA = [
            {
                sheet: 'Doctor Detail Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataFromExcel(dataArray) {
        var result = [];
        if (dataArray != null) {
            dataArray.forEach(x => {
                result.push({
                    DoctorID: x.DoctorID,
                    Name: x.Name,
                    Phone: x.Phone,
                    Role: x.Role === 1 ? "Intern" : x.Role === 2 ? "Part Time" : "Full Time",
                });
            }
            );
        }
        return result;
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={12} xs={12}>
                    {titleName}
                </Grid>

            </Grid>
        )
    }

    return (
        <>
            <Container maxWidth={false} >
                <Formik
                    enableReinitialize
                >
                    {({
                        errors,
                        handleBlur,
                        handleSubmit,
                        touched
                    }) => (
                        <form >
                            <Box mt={0}>
                                <Card sx={{ padding: '15px' }}>
                                    <CardHeader
                                        title={cardTitle(pageTitle)}
                                    />
                                    <Divider />
                                    <br />
                                    {doctorList.length > 0 ?
                                        <TableContainer>
                                            <Table sx={{ minWidth: 500 }} size="small" aria-label="a dense table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Doctor ID</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }} >Doctor Name</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Contact No</TableCell>
                                                        <TableCell align='left' sx={{ fontWeight: 'bold', textTransform: 'uppercase', fontSize: '15px' }}>Role</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? doctorList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : doctorList).map((row) => (
                                                            <TableRow key={row._id}>
                                                                <TableCell align='left'>{row.DoctorID}</TableCell>
                                                                <TableCell align='left'>{row.Name}</TableCell>
                                                                <TableCell align='left'>{row.Phone}</TableCell>
                                                                <TableCell align='left'>{row.Role === 1 ? "Intern" : row.Role === 2 ? "Part Time" : "Full Time"}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={4} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                            colSpan={5}
                                                            count={doctorList.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            slotProps={{
                                                                select: {
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                },
                                                            }}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                            ActionsComponent={TablePaginationActions}
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer>
                                        : null}
                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                        <Button
                                            color="primary"
                                            id="btnRecord"
                                            variant="contained"
                                            style={{ marginRight: '1rem' }}
                                            onClick={createFile}
                                            size="small"
                                        >
                                            EXCEL
                                        </Button>
                                        <div>&nbsp;</div>
                                        <ReactToPrint
                                            documentTitle={'Supplier Details Report'}
                                            trigger={() => (
                                                <Button
                                                    color="primary"
                                                    type="button"
                                                    variant="contained"
                                                    size='small'
                                                >
                                                    PDF
                                                </Button>
                                            )}
                                            content={() => componentRef.current}
                                        />
                                        <div hidden={true}>
                                            <DoctorDetailsReport
                                                ref={componentRef}
                                                doctorList={doctorList}
                                            />
                                        </div>
                                    </Box>
                                </Card>
                            </Box>
                        </form>
                    )}

                </Formik>
            </Container>
        </>
    )
}

export default DoctorReport